import { Injectable } from '@angular/core';
import { AppPartnerService, AppSettings, Branding } from '@galaxy/marketplace-apps';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { VDC_APP_ID } from '../../../globals';
import { AppConfig, AppConfigService } from '../app-config.service';
import { getCookie } from '../cookie';

@Injectable()
export class AppBrandingService {
  appBranding$$: BehaviorSubject<Branding> = new BehaviorSubject<Branding>(undefined);
  readonly appBranding$: Observable<Branding> = this.appBranding$$.asObservable();

  constructor(private appPartnerService: AppPartnerService, private appConfigService: AppConfigService) {
    this.appConfigService.config$
      .pipe(
        distinctUntilChanged(),
        switchMap((config: AppConfig) => {
          if (!config) {
            return of(null);
          }
          const partner_id = config && config.partner_id ? config.partner_id : getCookie('partner_id');
          const market_id = config && config.market_id ? config.market_id : '';
          return this.appPartnerService.getAppSettings(VDC_APP_ID, partner_id, market_id);
        }),
        map((appSettings: AppSettings) => (appSettings ? appSettings.branding : null)),
        catchError(() => of({} as Branding)),
      )
      .subscribe((branding) => this.appBranding$$.next(branding));
  }
}
